import './new_object';
import './add_new_property';
import './remove_property';
import './get_property';
import './set_property';


// WEBPACK FOOTER //
// ./src/botPage/view/blockly/blocks/objects/index.js